<template>
    <div class="viewer-wrapper">
      <v-tooltip :color="avatarColor.background">
        <template #activator="{ on }">
          <span v-on="on" class="viewer-avatar font-weight-bold text-sm-caption" :class="[avatarColor.background, avatarColor.text]">
            {{ initials }}
          </span>
        </template>
        <span class="font-weight-bold" :class="avatarColor.text">
          {{fullName}}
        </span>
      </v-tooltip>
      <transition name="notif" appear>
        <div v-if="showNotif" class="viewer-notif-box"
                :class="[avatarColor.background, avatarColor.text]" >
          <span class="font-weight-bold mr-1">{{ firstname || fullName }}</span>
          vient d'arriver sur le dossier
          <v-icon small class="pa-1" @click.stop="$emit('dismiss-notif')" :class="avatarColor.text">cancel</v-icon>
        </div>
      </transition>
    </div>
</template>


<script>
const AVATAR_COLORS = [
  { background: "red lighten-4", text: "red--text text--darken-3" },
  { background: "pink lighten-4", text: "pink--text text--darken-3" },
  { background: "purple lighten-4", text: "purple--text text--darken-3" },
  { background: "deep-purple lighten-4", text: "deep-purple--text text--darken-3" },
  { background: "indigo lighten-4", text: "indigo--text text--darken-3" },
  { background: "blue lighten-4", text: "blue--text text--darken-3" },
  { background: "light-blue lighten-4", text: "light-blue--text text--darken-3" },
  { background: "cyan lighten-4", text: "cyan--text text--darken-3" },
  { background: "teal lighten-4", text: "teal--text text--darken-3" },
  { background: "green lighten-4", text: "green--text text--darken-3" },
  { background: "light-green lighten-4", text: "light-green--text text--darken-3" },
  { background: "lime lighten-4", text: "lime--text text--darken-4" },
  { background: "yellow lighten-4", text: "yellow--text text--darken-4" },
  { background: "amber lighten-4", text: "amber--text text--darken-3" },
  { background: "orange lighten-4", text: "orange--text text--darken-3" },
  { background: "deep-orange lighten-4", text: "deep-orange--text text--darken-3" },
  { background: "brown lighten-4", text: "brown--text text--darken-3" },
  { background: "blue-grey lighten-4", text: "blue-grey--text text--darken-3" }
]

export default {
  name: "WidgetViewer",
  props : {
    viewer: { type: Object, required: true },
    showNotif: { type: Boolean, default: false }
  },
  computed : {
    firstname() {
      return this.viewer && this.viewer.firstname
          ? this.viewer.firstname.trim()
          : ""
    },
    lastname() {
      return this.viewer && this.viewer.lastname
          ? this.viewer.lastname.trim()
          : ""
    },
    fullName() {
      return `${this.firstname} ${this.lastname}`.trim()
    },
    initials() {
      const firstInitial = this.firstname
          ? this.firstname.slice(0, 1).toUpperCase()
          : ""

      const lastInitial = this.lastname
          ? this.lastname.slice(0, 1).toUpperCase()
          : ""

      return `${firstInitial}${lastInitial}` || "?"
    },
    avatarColor() {
      const userId = Number(this.viewer.userId || this.viewer.id || 0)
      const index = Math.abs(userId) % AVATAR_COLORS.length

      return AVATAR_COLORS[index]
    }
  }
}
</script>


<style scoped>

.viewer-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
}

.viewer-avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;

  width: 26px;
  height: 26px;

  border-radius: 50%;

  user-select: none;
  cursor: pointer;
}

.viewer-notif-box {
  position: absolute;
  z-index: 10;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  top: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);

  width: max-content;
  max-width: 260px;
  padding: 8px 12px;

  border-radius: 6px;

  font-family: inherit;
  font-size: 11px;
  line-height: 15px;
  text-align: left;

  user-select: none;
  cursor: default;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.14);
}

.viewer-notif-box::before {
  content: "";
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  border-right: 6px solid transparent;
  border-bottom: 6px solid currentColor;
  border-left: 6px solid transparent;
}

/* Notif Anim */
.notif-leave-active {
  transition:
      opacity 280ms ease-out,
      transform 280ms ease-out;
}

.notif-leave-to {
  opacity: 0;
  transform:
      translateX(-50%)
      translateY(-4px)
      scale(0.85);
}
</style>